import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import elementType from 'react-prop-types/lib/elementType';
import { prefix, splitBsProps, bsClass } from './utils/bootstrapUtils';
import PanelToggle from './PanelToggle';
import { PanelContext } from '../Panel/PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
class PanelTitle extends React.Component {
  render() {
    let {
      children
    } = this.props;
    const {
      className,
      toggle,
      componentClass: Component,
      ...props
    } = this.props;
    const {
      bsClass: _bsClass
    } = this.context || {};
    const [bsProps, elementProps] = splitBsProps(props);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    if (toggle) {
      children = /*#__PURE__*/_jsx(PanelToggle, {
        children: children
      });
    }
    return /*#__PURE__*/_jsx(Component, {
      ...elementProps,
      className: cn(className, prefix(bsProps, 'title')),
      children: children
    });
  }
}
PanelTitle.defaultProps = {
  componentClass: 'div'
};
PanelTitle.contextType = PanelContext;
export default bsClass('panel', PanelTitle);